/**
 * ============================================================
 * Label Engine
 * MiningSurveyWebGIS
 * ============================================================
 */

import L from "leaflet";
import Feature from "./feature.js";

class Label {
    /**
     * =========================================================
     * Bind Label
     * =========================================================
     */

    bind(feature, group = null) {
        const elevation = Feature.getElevation(feature);

        if (elevation === null) {
            return;
        }

        const layer = feature.layer;

        let labelLayer = null;

        // ===============================================
        // Point
        // ===============================================

        if (layer.getLatLng) {
            labelLayer = this.createPointLabel(layer.getLatLng(), elevation);
        }

        // ===============================================
        // Polyline / Polygon
        // ===============================================
        else if (layer.getBounds) {
            const latlngs = layer.getLatLngs();

            const center = this.getCenter(layer);

            const angle = this.getLineAngle(latlngs);

            labelLayer = this.createLineLabel(center, elevation, angle);
        }
        if (!labelLayer) return;

        feature.label = labelLayer;

        if (group) {
            group.addLayer(labelLayer);
        }
    }

    /**
     * =========================================================
     * Point Label
     * =========================================================
     */

    createPointLabel(latlng, elevation) {
        return L.marker(latlng, {
            panel: "labelPanel",
            interactive: false,

            icon: L.divIcon({
                className: "elevation-label",

                html: `
                    <div>
                        ${Number(elevation).toFixed(0)}
                    </div>
                `,
            }),
        });
    }

    /**
     * =========================================================
     * Line Label
     * =========================================================
     */

    createLineLabel(latlng, elevation, angle = 0) {
        return L.marker(latlng, {
            interactive: false,

            panel: "labelPanel",

            icon: L.divIcon({
                className: "contour-label",

                html: `
                <div
                    class="contour-label-text"
                    style="transform: rotate(${angle}deg);">
                    ${Number(elevation).toFixed(0)}
                </div>
            `,
            }),
        });
    }

    getLineAngle(latlngs) {
        if (!latlngs || latlngs.length < 2) {
            return 0;
        }

        const mid = Math.floor(latlngs.length / 2);

        const p1 = latlngs[Math.max(0, mid - 1)];
        const p2 = latlngs[Math.min(latlngs.length - 1, mid)];

        let angle = (Math.atan2(p2.lat - p1.lat, p2.lng - p1.lng) * 180) / Math.PI;

        // supaya tulisan tidak terbalik
        if (angle > 90) angle -= 180;
        if (angle < -90) angle += 180;

        return angle;
    }

    /**
     * =========================================================
     * Center
     * =========================================================
     */

    getCenter(layer) {
        if (layer.getBounds) {
            return layer.getBounds().getCenter();
        }

        return null;
    }

    /**
     * =========================================================
     * Show
     * =========================================================
     */

    show(feature, map) {
        if (!feature.label) return;

        map.addLayer(feature.label);
    }

    /**
     * =========================================================
     * Hide
     * =========================================================
     */

    hide(feature, map) {
        if (!feature.label) return;

        map.removeLayer(feature.label);
    }

    /**
     * =========================================================
     * Remove
     * =========================================================
     */

    remove(feature, map) {
        if (!feature.label) return;

        map.removeLayer(feature.label);

        feature.label = null;
    }
}

export default new Label();
